import { createSlice } from "@reduxjs/toolkit";
//import axios from "../lib/axios";
import axios from "axios";
import { config } from "../constants";

const initialState = {
  devices: [], // Each device has a saved trips property with saved trips in it
  vehiclesInUse: [],
  statusOfDevices: {},
  tags: [],
};

const slice = createSlice({
  name: "iotdevices",
  initialState,
  reducers: {
    changeMapDisplay(state, action) {
      const device = state.devices.find(item => String(item.imei) === String(action.payload.imei));
      if (device) device.map_display = action.payload.map_display;
    },
    getDevices(state, action) {
      state.devices = [...action.payload];
    },

    getVehicleTags(state, action) {
      state.tags = [...action.payload];
    },

    deleteGeofence(state, action) {
      let { imei, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, geofence_gps: null, geofence_meters: null };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },

    changeNickname(state, action) {
      let { imei, nickname, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, nickname };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },
    changeIcon(state, action) {
      let { imei, icon, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, avatar: icon };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },

    changeWebIconColor(state, action) {
      const { imei, color } = action.payload;
      const device = state.devices.find((entry) => entry.imei === imei);

      if (device) {
        device.web_icon_color = color;
      }
    },

    changeWebIconMovingColor(state, action) {
      const { imei, color } = action.payload;
      const device = state.devices.find((entry) => entry.imei === imei);

      if (device) {
        device.web_icon_moving_color = color;
      }
    },

    changePhoto(state, action) {
      let { imei, photo, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, photo };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },
    changeDriver(state, action) {
      let { imei, permdriver, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, permdriver };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },

    changeTags(state, action) {
      let { imei, tags, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, tags };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },
    changeVehicleGroups(state, action) {
      let { imei, groups, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = { ...device, groups };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },

    saveGeofence(state, action) {
      let { geofence, devices } = { ...action.payload };

      // Get Devices.

      let newDevices = [...devices];
      let index = newDevices.findIndex((entry) => entry.imei === geofence.imei);

      // Find Device
      if (index >= 0) {
        let device = { ...newDevices[index] };

        if (device) {
          device = {
            ...device,
            geofence_gps: geofence.geofence_gps,
            geofence_meters: geofence.geofence_meters,
          };
        }
        newDevices.splice(index, 1, device);
        state.devices = [...newDevices]; // Save Devices
      }
    },

    setVehicleStatus(state, action) {
      //Find All The Vehicles That Return.
      //Change Their Status
      //Change Their Address

      let vehicles = [...action.payload];

      for (let i = 0; i < vehicles.length; i++) {}

      state.devices = [...action.payload];
    },

    getVehiclesInUse(state, action) {
      state.vehiclesInUse = [...action.payload];
    },
    getStatusOfDevices(state, action) {
      state.statusOfDevices = { ...action.payload };
    },
  },
});

export const { reducer } = slice;

export const getDevices = () => async (dispatch) => {
  try {
    const { data } = await axios.post(`${config.api}/user/iotdevices`, {
      platform: config.platform,
    });

    data.sort((a, b) => {
      if (a.nickname.toLowerCase() < b.nickname.toLowerCase()) return -1;
      else return 1;
    });
    dispatch(slice.actions.getDevices(data));
  } catch (err) {
    console.log(err);
    //dispatch(slice.actions.getDevices([]));
  }
};

export const getVehiclesInUse = () => async (dispatch) => {
  const { data } = await axios.get(`${config.api}/vehicles/vehiclesinuse`);

  dispatch(slice.actions.getVehiclesInUse(data.vehiclesInUse));
};

export const getStatusOfDevices = () => async (dispatch) => {
  const { data } = await axios.get(`${config.api}/vehicles/activedevices`);

  dispatch(slice.actions.getStatusOfDevices(data));
};

export const saveGeofence = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;
  // Save Trip Here to Server And Locally

  await axios.post(`${config.api}/user/saveGeoFence`, {
    ...params,
  });

  dispatch(slice.actions.saveGeofence({ geofence: params, devices }));
};

export const changeIcon = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;
  // Save Trip Here to Server And Locally

  await axios.post(`${config.api}/user/changeicon`, {
    imei: params.imei,
    icon: params.icon,
  });

  dispatch(
    slice.actions.changeIcon({
      imei: params.imei,
      icon: params.icon,
      devices,
    })
  );
};

export const changeWebIconColor = (params) => async (dispatch) => {
  const { data } = await axios.patch(
    `${config.api}/v2/devices/${encodeURIComponent(params.imei)}/web-icon-color`,
    {
      color: params.color,
    },
  );

  dispatch(
    slice.actions.changeWebIconColor({
      imei: params.imei,
      color: data.web_icon_color,
    }),
  );

  return data;
};

export const changeWebIconMovingColor = (params) => async (dispatch) => {
  const { data } = await axios.patch(
    `${config.api}/v2/devices/${encodeURIComponent(params.imei)}/web-icon-moving-color`,
    {
      color: params.color,
    },
  );

  dispatch(
    slice.actions.changeWebIconMovingColor({
      imei: params.imei,
      color: data.web_icon_moving_color,
    }),
  );

  return data;
};

export const changeNickname = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;
  // Save Trip Here to Server And Locally

  await axios.post(`${config.api}/user/changenickname`, {
    imei: params.imei,
    nickname: params.nickname,
  });

  dispatch(
    slice.actions.changeNickname({
      imei: params.imei,
      nickname: params.nickname,
      devices,
    })
  );
};

export const changePhoto = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;

  // Save Trip Here to Server And Locally

  dispatch(
    slice.actions.changePhoto({
      imei: params.imei,
      photo: params.photo,
      devices,
    })
  );
};

export const changeDriver = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;

  const { imei, permdriver } = params;

  // Save Driver Here to Server And Locally

  try {
    const { data } = await axios.patch(
      `${config.api}/vehicles/vehicle?imei=${imei}`,
      {
        permdriver,
      }
    );
  } catch (err) {
    alert("ERROR FOR NOW");
  }

  dispatch(
    slice.actions.changeDriver({
      imei: params.imei,
      permdriver: params.permdriver,
      devices,
    })
  );
};

export const changeTags = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;
  // Save Trip Here to Server And Locally

  const { status } = await axios.post(`${config.api}/vehicles/vehicleTags`, {
    imei: params.imei,
    tag_ids: params.tags,
  });

  dispatch(
    slice.actions.changeTags({
      imei: params.imei,
      tags: params.tags,
      devices,
    })
  );
};

export const changeVehicleGroups = (params) => async (dispatch, getState) => {
  const { devices } = getState().iotdevices;
  // Save Trip Here to Server And Locally

  const { status } = await axios.post(`${config.api}/vehicles/groups`, {
    imei: params.imei,
    compgroups_ids: params.groups,
  });

  dispatch(
    slice.actions.changeVehicleGroups({
      imei: params.imei,
      groups: params.groups,
      devices,
    })
  );
};

export const deleteGeofence =
  ({ imei }) =>
  async (dispatch, getState) => {
    const { devices } = getState().iotdevices;
    // Save Trip Here to Server And Locally
    await axios.post(`${config.api}/geofences/deleteGeofence`, {
      imei,
    });

    dispatch(slice.actions.deleteGeofence({ imei, devices }));
  };

export const getVehicleStatus = (vehicles) => async (dispatch) => {
  const { data: vehicleStatus } = await axios.get(
    `${config.api}/vehicles/status`,
    {
      params: {
        region: config.region,
        devices: `${vehicles.map((item, index) => item.imei).join(",")}`,
      },
    }
  );

  dispatch(slice.actions.setVehicleStatus(vehicleStatus));
};

export const getVehicleTags = () => async (dispatch) => {
  let { data: tags } = await axios.get(`${config.api}/accounts/companyTags`, {
    params: { type: 2 },
  });

  dispatch(slice.actions.getVehicleTags(tags));
};

export default slice;

export const updateMapDisplay = slice.actions.changeMapDisplay;
